import * as React from 'react';

import useSponsorAdsBanner from 'data/queries/useSponsorAdsBanner';
import useSponsorAdsBannerMobile from 'data/queries/useSponsorAdsBannerMobile';
import * as style from 'styles/components/homepage/sponsorAds.module.scss';
// import FormattedMessage from 'components/utils/FormattedMessage';

const SponsorAdsBanner = () => {
    const sponsorAds = useSponsorAdsBanner();
    const sponsorAdsMobile = useSponsorAdsBannerMobile();

    const fullwidthClass = sponsorAds.length === 1 ? "fullwidth" : "";
    const fullwidthMobileClass = sponsorAdsMobile.length === 1 ? "fullwidth" : "";

    // console.log(sponsorAds);
    // console.log(sponsorAdsMobile);

    return (
        <>
            <div className={`wrapper  ${style.sponsorAds__desktop}`}>
                <div className={`wrappers ${style.sponsorAds} ${fullwidthClass}`}>
                    {sponsorAds.map((item, index) => (
                        <div key={index}>
                            { /*
                            <div className={style.sponsorAds__adMark}>
                                <FormattedMessage id="global.ad" />
                            </div>
                            */ }
                            <a
                                href={item.url}
                                target={item.external ? '_blank' : null}
                                rel="noreferrer"
                            >
                                <img src={item.image.asset.url} alt={item.alt} />
                            </a>
                        </div>
                    ))}
                </div>
            </div>
            <div className={`wrapper ${style.sponsorAds__mobile}`}>
                <div className={`wrappers ${style.sponsorAds} ${fullwidthMobileClass}`}>
                {sponsorAdsMobile.map((item, index) => (
                    <div key={index}>
                        { /*
                        <div className={style.sponsorAds__adMark}>
                            <FormattedMessage id="global.ad" />
                        </div>
                        */ }
                        <a
                            key={index}
                            href={item.url}
                            target={item.external ? '_blank' : null}
                            rel="noreferrer"
                        >
                            <img src={item.image.asset.url} alt={item.alt} />
                        </a>
                    </div>
                ))}
                </div>
            </div>
        </>
    );
};

export default SponsorAdsBanner;
